export default "__VITE_ASSET__4nWHunp3__"